import { camelize } from '@ember/string';
export function getFelicaBrandDisplayName(felicaBrand, intl) {
  switch (felicaBrand && camelize(felicaBrand.toLowerCase())) {
    case 'felicaId':
      return intl.t('common.felicaBrands.id');
    case 'felicaTransportation':
      return intl.t('common.felicaBrands.transportation');
    case 'felicaQp':
      return intl.t('common.felicaBrands.quicpay');
    default:
      return null;
  }
}